'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iBem = require('../../i-bem/i-bem.react');

var _bIcon = (require('./../../icon/icon.react.js').default || require('./../../icon/icon.react.js')).applyDecls();

var _bIcon2 = _interopRequireDefault(_bIcon);

var _bLogo = (require('./../../logo/logo.react.js').default || require('./../../logo/logo.react.js')).applyDecls();

var _bLogo2 = _interopRequireDefault(_bLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'header2',
    elem: 'logo',
    mods: function mods(_ref) {
        var size = _ref.size,
            preset = _ref.preset;

        return { size: size, preset: preset };
    },
    content: function content(_ref2) {
        var name = _ref2.name,
            url = _ref2.url,
            service = _ref2.service,
            children = _ref2.children;

        var type = url ? 'link' : undefined;

        if (children) {
            return children;
        }

        return [_react2.default.createElement(_bLogo2.default, _extends({ key: 'main' }, {
            url: url,
            name: name,
            type: type })), service && _react2.default.createElement(_bIcon2.default, _extends({ key: 'service' }, {
            mix: [{ block: 'header2', elem: 'logo' }, { block: 'logo', mods: { service: 'yes' } }] }))];
    }
});